import api from "../services/api";

export const previewSegmentCount = (payload) =>
  api.post("/api/contact-segments/preview", payload);

export const saveSegment = (payload) =>
  api.post("/api/contact-segments/save", payload);
